export const modalNonUserClosable = {
  backdrop: true,
  ignoreBackdropClick: true,
  keyboard: false
};